import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberResourcesPage from "@/pages/member/MemberResourcesPage";

export const Route = createFileRoute("/member/resources")({
  head: () => pageHead("Member · Resources", "AKIVA member · resources portal.", "/member/resources", true),
  component: MemberResourcesPage,
});
